//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.SheetMetal.SheetmetalBaseBuilder.js";
import "../no/Section.js";
let d=[[[0,"AddedGeometry",1,"Section",0],[0,"ExtractGussetCurves",1,0],[0,"FaceCollector",1,"ScCollector",0],[0,"HideOriginalCurves",1,0],[0,"ReferenceEntity",1,"NXObject",0]],[[[],"ValidateBuilderData",{R_:{validity_code:''}},0,0],[["face"],"IsValidFaceForUnbend",{R_:{isValidFace:''}},1,0],[["stationaryEdge"],"IsValidStationaryEdgeForUnbend",{R_:{isValidStationaryEdge:''}},1,0],[["stationaryFace"],"IsValidStationaryFaceForUnbend",{R_:{isValidStationaryFace:''}},1,0]],[]];
SPLM.Features.SheetMetal.UnbendBuilder = class extends SPLM.Features.SheetMetal.SheetmetalBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.UnbendBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;